import axios from "axios";
import Config from "src/config";

const v1_actionEnviarFigurinhaSalva = (id, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/figurinhas/${id}/enviar`,
        data,
    });
};

export default v1_actionEnviarFigurinhaSalva;
